import { useMutation, useQueryClient } from '@tanstack/react-query'

import { responsibleMedicalRecordInstance } from '../..'
import { getListResponsibleMedicalRecordQueryKey } from './useListResponsibleMedicalRecordQuery'
import { getResponsibleMedicalRecordQueryKey } from './useResponsibleMedicalRecordQuery'

export function getSetResponsibleMedicalRecordExpiredMutationKey() {
  return ['setResponsibleMedicalRecordExpired']
}

export function useSetResponsibleMedicalRecordExpiredMutation({
  onSuccess,
  onError
}: {
  onSuccess?: () => void
  onError?: () => void
} = {}) {
  const queryClient = useQueryClient()
  return useMutation({
    mutationKey: getSetResponsibleMedicalRecordExpiredMutationKey(),
    mutationFn: async (params: { id: string }) =>
      await responsibleMedicalRecordInstance.setResponsibleMedicalRecordExpired(
        params
      ),
    onSuccess: (_, { id }) => {
      queryClient.invalidateQueries({
        queryKey: getResponsibleMedicalRecordQueryKey(id)
      })
      queryClient.invalidateQueries({
        queryKey: getListResponsibleMedicalRecordQueryKey()
      })
      onSuccess?.()
    },
    onError: () => {
      onError?.()
    }
  })
}
